import FloorFilter from "../data/floor-filter";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-filter-button.module.scss";
import IconFloors from "../dynamicicons/icon-floors";
import IconFloorCurrent from "../dynamicicons/icon-floor-current";
import { mapFloorNumber } from "../helper/language-helper";
import whitelabel from "../whitelabel";

export interface FloorFilterButtonProps {
	selection?: number;
	onChange: (filter: FloorFilter) => void;
}

export default function FloorFilterButton(props: FloorFilterButtonProps) {
	const { t } = useTranslation();
	const selection = props.selection;
	const onChange = props.onChange;

	const toggle = useCallback(() => {
		if (selection === undefined) {
			onChange(FloorFilter.Current);
		} else {
			onChange(FloorFilter.All);
		}
	}, [selection, onChange]);

	return (
		<div className={styles.floorButtonWrapper}>
			<button className={styles.floorButton} onClick={toggle}>
				{props.selection === undefined ? (
					<>
						<IconFloors color={whitelabel.palette.secondary700} />
						<span>{t("floor_filter.all")}</span>
					</>
				) : (
					<>
						<IconFloorCurrent
							color={whitelabel.palette.secondary700}
						/>
						<span>{mapFloorNumber(props.selection, t)}</span>
					</>
				)}
			</button>
		</div>
	);
}
